module.exports = __webpack_public_path__ + "img/tab203.c0080310.png";